<!-- 入驻加盟状态模板 -->
<style lang="scss" scoped>
.status-template-wrapper {
  height: 478px;
  background: #ffffff;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    text-align: center;
  }
}
</style>

<template>
  <div class="status-template-wrapper">
    <div class="content">
      <!-- 待审核 -->
      <template v-if="status === JOIN_STATUS.WAIT_AUDIT">
        <icon size="60" class="mb-16px text-#EE9D25" type="yiyuan-dengdaizhong"></icon>
        <div class="mb-8px text-20px font-semibold">待审核</div>
        <div class="text-16px text-#666666">请耐心等待审核</div>
      </template>
      <!-- 审核驳回 -->
      <template v-if="status === JOIN_STATUS.AUDIT_REJECT">
        <icon size="60" class="mb-16px text-#F5222D" type="yiyuan-shenhebohui"></icon>
        <div class="mb-8px text-20px font-semibold">审核驳回</div>
        <div class="text-16px text-#666666">被驳回，驳回原因：{{ failReason }}</div>
        <div class="mt-60px">
          <el-button size="large" @click="cancel">取消</el-button>
          <el-button type="primary" size="large" @click="resubmit">重新提交</el-button>
        </div>
      </template>
      <!-- 审核通过待签署协议 -->
      <template v-if="status === JOIN_STATUS.WAIT_SIGN">
        <icon size="60" class="mb-16px text-#EE9D25" type="yiyuan-dengdaizhong"></icon>
        <div class="mb-8px text-20px font-semibold">您提交的信息审核通过，请尽快签署协议</div>
        <div class="mt-60px">
          <el-button type="primary" size="large" @click="signAgreement">立即签署</el-button>
        </div>
      </template>
      <!-- 已发起签署 -->
      <template v-if="status === JOIN_STATUS.SIGN_START">
        <icon size="60" class="mb-16px text-#EE9D25" type="yiyuan-dengdaizhong"></icon>
        <div class="mb-8px text-20px font-semibold">已发起签署，请查收e签宝短信尽快完成签约</div>
        <div class="mt-60px">
          <el-button type="primary" size="large" @click="viewProtocol">查看协议</el-button>
        </div>
      </template>
      <!-- 签约已过期 -->
      <template v-if="status === JOIN_STATUS.SIGN_EXPIRED">
        <icon size="60" class="mb-16px text-#F5222D" type="yiyuan-guoqijingshi"></icon>
        <div class="mb-8px text-20px font-semibold">签约已过期，请重新发布起签约</div>
        <div class="text-16px text-#666666">如有疑问，请联系平台客服经理</div>
        <div class="mt-60px">
          <el-button type="primary" size="large" @click="signAgreement">立即签署</el-button>
        </div>
      </template>
    </div>
  </div>
  <ProtocolDialog ref="protocolDialog" @signSuccess="signSuccess" />
</template>

<script setup>
import { ref } from 'vue'
import ProtocolDialog from './protocol-dialog.vue'
import { JOIN_TYPE_ENUM_MAP } from '@/constants/common'
import userApi from '@/apis/user'
import event from '@/event/index'
import { CLOSE_JOIN_CORP_DIALOG } from '@/event/modules/site'
import { JOIN_STATUS } from './data'

const props = defineProps({
  status: {
    //入驻状态
    type: Number,
    default: 0,
  },
  failReason: {
    //驳回原因
    type: String,
    default: '',
  },
  resubmit: {
    //重新提交
    type: Function,
    default: () => {},
  },
  corpType: {
    //加盟类型
    type: Number,
    default: 0,
  },
  corpId: {
    //企业id
    type: String,
    default: '',
  },
  nextStep: {
    type: Function,
    default: () => {},
  },
  close: {
    type: Function,
    default: () => {},
  },
})

const protocolDialog = ref(null)
//立即签署
const signAgreement = () => {
  protocolDialog.value.open({ url: JOIN_TYPE_ENUM_MAP[Number(props.corpType)], corpId: props.corpId })
}

//查看协议
const viewProtocol = async () => {
  const res = await userApi.getSignAgreementUrl({ corpId: props.corpId })
  window.open(res.signUrl, '_blank')
}

//签署成功
const signSuccess = () => {
  props.nextStep()
}

//审核驳回取消
const cancel = async () => {
  try {
    await userApi.postCancelJoinProcess({ corpId: props.corpId })
    event.emit(CLOSE_JOIN_CORP_DIALOG) //关闭合伙人入驻流程窗口
    // event.emit(OPEN_PARTNER_MODE_DIALOG) //打开合伙人模式选择窗口
  } catch (error) {
    console.log(error)
  }
}
</script>
